/* eslint-disable prefer-destructuring */
/* eslint-disable no-restricted-globals */
/* eslint-disable no-shadow */
/* eslint-disable no-use-before-define */
/* eslint-disable eqeqeq */
import React, { useEffect, useState, useMemo } from 'react';
import { Form } from 'react-form';
import PropTypes, { any } from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import NavigationPrompt from 'react-router-navigation-prompt';
import * as queryString from 'query-string';
import Modal from '../../components/Modal/ReactBootstrapModal';

import DrawsSidebarLeftV3 from './DrawsSidebarLeftV3';
import DrawsHeaderV2 from './DrawsHeaderV2';
import DrawsSubHeaderV2 from './DrawsSubHeaderV2';
import PlayersTabV3 from './PlayersTabV3';
import ManageAccountsTab from './ManageAccountsTab';
import CheckInTab from './CheckInTab';
import DrawsPlayerListWrapperV2 from './DrawsPlayerListWrapperV2';
import ScheduleTabV2 from './ScheduleTab/ScheduleTabV2';
import LocationsTabV2 from './LocationsTab/LocationsTabV2';
import OfficialsTabV2 from './OfficialsTabV2';
import RoundsV2 from './RoundsV2';

import { MessagePopUp, CreateDrawsWelcomePopUp, MaxPostScoreDateCrossedPopUp, ConfirmActionPopup } from '../../components/PopUps';

import Img from '../../components/Img';
import LocationsSubHeaderV2 from './LocationsTab/LocationsSubHeaderV2';
import EventPostScorePopup from '../../components/PopUps/EventPostScorePopup';

import * as drawEditActions from '../../actions/draw-edit-actions';
import { showErrorPopup } from '../../actions/notification-actions';
import { addRecepient, setNewConv } from '../../actions/messaging-actions';
import { directorRoleIds, drawEliminationTypeIds, divisionFormatTypeIds, drawCategoryTypeIds, maxUtrRatingDiffInDraw, drawAutofillTypeIds, ballTypes, ballTypeIds, utrTypeIds, eventStateTypeIds } from '../../utils/eventConstants';
import { parseDrawResponse, getMembersInTeams, getAvailablePlayersForDrawV2, getAvailableTeamsForDrawV2, allowDrawCreation } from '../../utils/draws';
import { validatePTTRoundRobinPositionV2, doesPlayersHaveUtrDiff, isDoublesFormat, isSinglesFormat, isEventOfficialHsEvent, isTennisSportTypeEvent, isOrganizer, EventTypes } from '../../utils/events';

import { PTT_EVENT_TOUR_ID } from '../../utils/constants';
import { getLabelByTypeId, getValueByTypeId } from '../../utils/types';
import EventDrawCreateEditPopup from '../../components/PopUps/EventDrawCreateEditPopup';
import CourtSchedular from './CourtSchedular';
import AutomatedDrawCreatePopup from '../../components/PopUps/AutomatedDrawCreatePopup';
import { DateTimePicker } from '../../components/Form';
import Collapsible from '../../components/Form/Collapsible';
import { EventDeskTabKeys } from '../../utils/eventDeskConstants';
import useCourtSchedularUnpublishedChangesGuard from './CourtSchedular/useCourtSchedularUnpublishedChangesGuard';
import NotificationsTab from './NotificationsTab';
import DayPlanner from './DayPlanner';
import EventScheduleTypeSelection from './EventScheduleTypeSelection';
import NextAvailable from './NextAvailable';
import Popup from '../../components/Popup';
import popupStyles from '../../components/PopUps/EventDrawCreateEditPopup/eventDrawCreateEditPopup.scss';
import EventDeskFailedMembersPopup from '../../components/PopUps/EventDeskFailedMembersPopup';
import { isFlexLeagueClubV2 } from '../../utils/clubs';
import { useStatsig } from '../../components/hooks/useStatsig';

import styles from './drawEdit.scss';
import { getDrawName, dateFormat } from '../../utils/courtSchedular';
import { createTypeByIdDict } from '../../utils/formatting';
import SingleCheckbox from '../SearchPage/Filters/FilterComponents/CoreComponents/SingleCheckbox';
import PrintSpoolerTab from './PrintSpoolerTab';
import withStatsigEventUpdate from '../../components/hocs/withStatsigEventUpdate';
import Splash from '../../components/Splash';

const getPublishButtonLabel = (isPublishing, isLoading) => {
    if (isPublishing) {
        return 'Publishing...';
    }
    if (isLoading) {
        return 'Loading...';
    }
    return 'PUBLISH';
};

const DrawEditPageV2 = ({ match, history, location }) => {
    const { checkGate, featureGates } = useStatsig();
    const coreUI = useSelector(({ coreUI }) => coreUI);
    const user = useSelector(({ auth }) => auth.user);
    const { event, draws, currentDraw, parentDraw, players, teams, locations, officials, isSaving,
        isPublishing, selected, selectedLength, selectedTeams, selectedTeamsLength, preventSelectMove, failedMemberIds, drawDivision, associatedDivisionIds, associatedDivisionsByDrawId, drawsForPublish } = useSelector(({ drawEdit }) => {
            const { event, draws, currentDraw, parentDraw, players, teams, locations, officials, isSaving, isPublishing, selected, selectedTeams, preventSelectMove, failedMemberIds, drawDivision, associatedDivisionIds, associatedDivisionsByDrawId, drawsForPublish } = drawEdit;
            return {
                event,
                draws,
                currentDraw,
                parentDraw,
                players,
                teams,
                locations,
                officials,
                isSaving,
                isPublishing,
                selected,
                selectedLength: selected.length,
                selectedTeams,
                selectedTeamsLength: selectedTeams.length,
                preventSelectMove,
                failedMemberIds,
                drawDivision,
                associatedDivisionIds,
                associatedDivisionsByDrawId,
                drawsForPublish,
            };
        });
    const courtScheduler = useSelector(({ courtScheduler }) => courtScheduler);
    const dayPlanner = useSelector(({ dayPlanner }) => dayPlanner);
    const dispatch = useDispatch();

    const queryParams = queryString.parse(location.search);
    const eventSchedule = event.data?.eventSchedule || null;
    const timeZone = eventSchedule ? eventSchedule.timeZone : null;
    const utrTypeId = event.data?.utrTypeId ?? '';
    const isPTTEvent = event.data?.eventTours.some(tour => tour.id === PTT_EVENT_TOUR_ID);
    const sportTypeId = event.data?.sportTypeId;
    const scheduleTypeId = event.data?.scheduleTypeId;
    const clubId = event.data?.club?.id;
    const clubTierTypeId = event.data?.club?.tierType?.id;
    const isFlexLeagueClub = isFlexLeagueClubV2(clubTierTypeId);
    const isDrawCreationAllowed = allowDrawCreation(event.data);

    const { genderTypes, utrTypes, draw: { drawCategoryTypes } } = coreUI.types.tms;
    const drawCategoryTypesDict = createTypeByIdDict(drawCategoryTypes);
    const utrType = getValueByTypeId(utrTypes, utrTypeId);
    const isVerifiedEvent = utrTypeId === utrTypeIds.SANCTIONED;
    const { formatTypes, tournament: { drawEliminationTypes, scoringTypes } } = coreUI.types.tms.division;

    const [isReadOnly, setIsReadOnly] = useState(false);
    const [isLocked] = useState(false);
    const [activeView, setActiveView] = useState(queryParams.v || 'drawEditor');
    const [drawsNav, setDrawsNav] = useState({ open: false });
    const isCurrentMemberAdmin = (user && isOrganizer(event?.data));
    const isFlexLeagueEvent = event?.data?.eventTypeId === EventTypes.FLEX_LEAGUE;

    const [move, setMove] = useState({
        showModal: false,
        fromDrawId: null,
        toDrawId: null,
    });
    const [publish, setPublish] = useState({
        publishing: false,
        selected: [],
        showModal: false,
    });
    const [drawEditModal, setDrawEditModal] = useState({ showModal: false });
    const [drawCreateModal, setDrawCreateModal] = useState({ showModal: false });
    const [unsavedModal, setUnsavedModal] = useState({ showModal: false });
    const [drawCreateWelcomeModal, setDrawCreateWelcomeModal] = useState({ showModal: false });
    const [showDrawDivisionAssociationPopup, setShowDrawDivisionAssociationPopup] = useState();
    const [postScore, setPostScore] = useState({ showModal: false });
    const [autofill, setAutofill] = useState({
        showModal: false,
        drawId: null,
        roundId: null,
        isRoundAutoFill: false,
        selected: [],
        selectedTeams: [],
    });
    const [autofillRatingWarning, setAutofillRatingWarning] = useState({
        showModal: false,
        drawId: null,
        roundId: null,
    });
    const [locationsTab] = useState({ title: 'Locations/Courts' });
    const [officialsTab] = useState({ title: 'Officials' });

    const [selectedRound, setSelectedRound] = useState(0);

    const [allPlayersListFilters, setAllPlayersListFilters] = useState({ gender: '' }); // gender filter for all players
    const [drawListFilter, setDrawListFilter] = useState('');

    const [message, setMessage] = useState({ showModal: false });
    const [confirmation, setConfirmation] = useState(false);
    const [displayScheduleModal, setDisplayScheduleModal] = useState(false);

    const [showPostScoreDateCrossed, setShowPostScoreDateCrossed] = useState(true);
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [selectedFacility, setSelectedFacility] = useState(0);
    const [excludedCourtIds, setExcludedCourtIds] = useState([]);
    const [PTTError, setPTTError] = useState(null);
    const [eventName, setEventName] = useState('');

    const [eventLocationsLength, setEventLocationsLength] = useState(null);

    const [showConfirmDeleteDraw, setShowConfirmDeleteDraw] = useState(false);
    const [toDeleteDrawId, setToDeleteDrawId] = useState(null);
    const [submittingDeleteDraw, setSubmittingDeleteDraw] = useState(false);

    // create player groups and placement lists from draw data
    const {
        membersHaveResults = [],
        membersPlaced = [],
        teamsPlaced = [],
        teamsHaveResults = [],
        membersInDraw = [],
        membersInWaitlist = [],
        membersInDrawDict = {},
        teamsInDraw = [],
        teamsInDrawDict = {},
        teamsInWaitlist = [],
    } = useMemo(() => parseDrawResponse(currentDraw.data), [currentDraw.data]);
    const { playersDict = {}, playersDictByMemberId = {} } = players;
    const { teamsDict = {} } = teams;
    const isOfficialHSEvent = isEventOfficialHsEvent(event.data);
    const isScheduleDrawsEnabled = checkGate(featureGates.EVENT_DESK_SCHEDULE_DRAWS);
    const [scheduleDrawDateToDisplay, setScheduleDrawDateToDisplay] = useState(null);
    const [drawsDropDown, setDrawsDropDown] = useState({ allSelected: false, groups: draws.data });
    const [showConfirmDeleteScheduledDraw, setShowConfirmDeleteScheduledDraw] = useState(false);
    const [showConfirmSchedulePublishDraw, setShowConfirmSchedulePublishDraw] = useState(false);
    const [drawsScheduledToCancel, setDrawsScheduledToCancel] = useState([]);

    const shouldDisableSchedulePublishButton = useMemo(() => {
        const publishedUnselectedDraws = drawsDropDown?.groups?.flatMap(group => group.draws?.filter(draw => !draw.selected && draw.published));
        if (publishedUnselectedDraws?.length > 0) {
            return true;
        }

        const selectedDrawsToPublish = drawsDropDown?.groups?.flatMap(group => group.draws?.filter(draw => draw.selected && !draw.published));
        const unSchedulableSelectedDraws = selectedDrawsToPublish?.filter(draw => !draw?.isSchedulable);
        if (unSchedulableSelectedDraws?.length > 0) {
            return true;
        }

        return selectedDrawsToPublish?.length === 0;
    }, [drawsDropDown]);

    useEffect(() => {
        setEventName(event.data?.name);
    }, [event.data]);

    if (!eventLocationsLength && locations.data?.length) {
        const excludedCourts = [];
        locations.data.forEach(loc => {
            loc.facilities.forEach(facility => {
                facility.courts.forEach(court => {
                    if (court.enabled === false) {
                        excludedCourts.push(court.id);
                    }
                });
            });
        });
        setExcludedCourtIds(excludedCourts);
        setEventLocationsLength(locations.data.length);
    }

    const loadEvent = async () => {
        const res = await dispatch(drawEditActions.getEvent(match.params.eventId));
        if (res.memberEventDirectorRoleId === directorRoleIds.VOLUNTEER && !isCurrentMemberAdmin) {
            setActiveView(EventDeskTabKeys.CHECK_IN);
        } else {
            await dispatch(drawEditActions.getOrganizerRatings({ eventId: match.params.eventId }));
        }
    };

    useEffect(() => {
        window.addEventListener('beforeunload', onUnload);

        // eslint-disable-next-line eqeqeq
        if (event?.error) {
            history.push(`/events/${match.params.eventId}`);
        } else {
            dispatch(drawEditActions.reInitRedux());
            loadEvent();
            if (isCurrentMemberAdmin) {
                dispatch(drawEditActions.getDrawsPublishInfo(match.params.eventId));
            }
        }
        return () => {
            window.removeEventListener('beforeunload', onUnload);
        };
    }, []);

    useEffect(() => {
        if (event.error) {
            history.push(`/events/${match.params.eventId}`);
        } else {
            // no redirect needed
        }
    }, [event.error]);

    useEffect(() => {
        if (event.data && activeView === 'drawEditor') {
            if (!currentDraw.data?.id) {
                setInitState();
            }
        }
        if (event.data?.id && officials.data === null && queryParams.d) {
            dispatch(drawEditActions.getDrawOfficials(event.data?.id, queryParams.d));
        }
        const isRegistrationOpen = event.data?.registrationStateId === eventStateTypeIds.OPEN_REGISTRATION;
        if (event.data?.divisionDrawAssociation && !event.data?.confirmDivisionDrawAssociation && !isRegistrationOpen) {
            setShowDrawDivisionAssociationPopup(true);
        }
    }, [event.data]);

    const hasDrawResults = (drawId) => {
        const eventDrawObject = draws?.data?.find(draw => draw.id === drawId);
        return eventDrawObject?.hasResults || eventDrawObject?.childDraws?.some(cd => cd.hasResults);
    };

    useEffect(() => {
        const drawsGroups = drawsForPublish?.map((group) => {
            return {
                ...group,
                draws: group.draws.map(draw => {
                    return {
                        ...draw,
                        selected: draw.published || false,
                        // disable published draws that have results
                        disabled: draw.published && hasDrawResults(draw.id),
                        isSchedulable: !draw.published,
                    };
                }),
                // select parent checkbox if all childre are selected
                selected: group.draws?.every(draw => draw.published),
                // disable parent checkbox if all children have results and are disabled
                disabled: group.draws?.every(draw => draw.published && hasDrawResults(draw.id)),
                isOpen: false,
            };
        });

        setDrawsDropDown({ ...drawsDropDown, groups: drawsGroups });
    }, [drawsForPublish]);

    const loadDrawFromQueryParam = (targetDrawId) => {
        const matchingParentDraw = draws.data.find(parentDraw => parentDraw.id === targetDrawId);
        if (matchingParentDraw) {
            dispatch(drawEditActions.getDraw({ eventId: event.data.id, drawId: matchingParentDraw.id, setAsCurrentDraw: true }));
            return;
        }
        const parentOfMatchingChild = draws.data.find(parentDraw => parentDraw.childDraws.some(childDraw => childDraw.id === targetDrawId));
        if (parentOfMatchingChild) {
            dispatch(drawEditActions.getDraw({ eventId: event.data.id, drawId: parentOfMatchingChild.id }));
            dispatch(drawEditActions.getDraw({ eventId: event.data.id, drawId: targetDrawId, isChildDraw: true }));
        }
    };

    useEffect(() => {
        if (event.data && draws.data?.length) {
            // load draw by queryParam.d id
            if (queryParams.d && (currentDraw.data === null || currentDraw.data?.id !== queryParams.d)) {
                loadDrawFromQueryParam(queryParams.d);
            } else if (activeView === 'drawEditor' && (!currentDraw.data || (queryParams.d && currentDraw.data && !draws.drawsDict[currentDraw.data.id]))) {
                // load first draw
                dispatch(drawEditActions.getDraw({ eventId: event.data.id, drawId: draws.data?.[0]?.id, setAsCurrentDraw: true }));
                history.replace({
                    search: `?v=drawEditor&d=${draws.data[0].id}`,
                });
            } else if (activeView === 'drawEditor' && currentDraw.data && !queryParams.d) {
                history.replace({
                    search: `?v=drawEditor&d=${currentDraw.data.id}`,
                });
            } else {
                // do nothing
            }
        }
    }, [draws.data]);

    useEffect(() => {
        const isRoundRobin = currentDraw.data?.eliminationTypeId === drawEliminationTypeIds.ROUND_ROBIN;
        if (isPTTEvent && isRoundRobin && (currentDraw.data?.rounds.length === 3 || currentDraw.data?.rounds.length === 5)) {
            setPTTError(validatePTTRoundRobinPositionV2(currentDraw.data));
        }
        if (activeView === 'drawEditor' && currentDraw.data?.id && queryParams.d && currentDraw.data.id !== queryParams.d) {
            history.replace({
                search: `?v=drawEditor&d=${currentDraw.data.id}`,
            });
        }
    }, [currentDraw.data]);

    useEffect(() => {
        const excludedCourts = [];
        if (locations?.data?.length) {
            locations.data.forEach(loc => {
                loc.facilities.forEach(facility => {
                    facility.courts.forEach(court => {
                        if (court.enabled === false) {
                            excludedCourts.push(court.id);
                        }
                    });
                });
            });
            setExcludedCourtIds(excludedCourts);
            setEventLocationsLength(locations.data.length);
        }
    }, [locations.data]);

    const setInitState = () => {
        const excludedCourts = [];
        let selectedLoc = null;
        if (locations?.data?.length) {
            locations.data.forEach(loc => {
                loc.facilities.forEach(facility => {
                    facility.courts.forEach(court => {
                        if (court.enabled === false) {
                            excludedCourts.push(court.id);
                        }
                    });
                });
            });
            if (queryParams.l) {
                selectedLoc = locations.data.find(loc => loc.id === queryParams.l);
            }
        }
        setExcludedCourtIds(excludedCourts);
        setSelectedLocation(selectedLoc);
        if (!queryParams.d && draws.data?.[0]?.id) {
            history.replace({
                search: `?d=${draws.data[0].id}`,
            });
        }
        if (queryParams.welcome) {
            toggleDrawsNav();
            toggleCreateDrawWelcomePopUp();
        }
    };

    const onUnload = (e) => {
        // browser api handles the warning
        if (currentDraw.unsavedChanges) {
            e.returnValue = 'Leave page? Changes you made may not be saved.';
        }
    };

    const closeClickHandler = () => {
        history.push(`/events/${event.data.id}`);
    };

    const handleSaveClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        dispatch(drawEditActions.saveDrawUpdates({ reload: true }));
    };

    const handleDrawDeleteClick = (drawId) => {
        setToDeleteDrawId(drawId);
        setShowConfirmDeleteDraw(true);
    };

    const handleDrawEditClick = (draw, parentDraw) => {
        dispatch(drawEditActions.setResetTimer(true));
        setUnsavedModal({ showModal: false });
        setDrawEditModal({
            ...drawEditModal,
            showModal: true,
            draw,
            parentDraw,
        });
    };

    const onCloseDrawDeleteConfirmPopup = () => {
        setToDeleteDrawId(null);
        setShowConfirmDeleteDraw(false);
    };

    const handleDrawDeleteConfirmation = () => {
        setSubmittingDeleteDraw(true);
        dispatch(drawEditActions.deleteDraw(event.data.id, toDeleteDrawId)).then(() => {
            setSubmittingDeleteDraw(false);
            onCloseDrawDeleteConfirmPopup();
        });
    };

    const handleDrawTabClick = async (draw) => {
        setSelectedRound(0);
        dispatch(drawEditActions.setSelected([]));
        dispatch(drawEditActions.setSelectedTeams([]));
        if (draw.id !== currentDraw.data?.id) {
            history.replace({
                search: `?v=drawEditor&d=${draw.categoryTypeId === drawCategoryTypeIds.GROUPED ? draw.childDraws[0].id : draw.id}`,
            });
            await dispatch(drawEditActions.getDraw({
                eventId: event.data.id,
                drawId: draw.id,
                setAsCurrentDraw: true,
            }));
        }
        setActiveView('drawEditor');
        setUnsavedModal({ showModal: false });
    };

    const handleChildDrawClick = async (e, drawId) => {
        if (e) {
            e.stopPropagation();
        }
        setSelectedRound(0);
        dispatch(drawEditActions.setSelected([]));
        dispatch(drawEditActions.setSelectedTeams([]));
        history.replace({
            search: `?v=drawEditor&d=${drawId}`,
        });
        await dispatch(drawEditActions.getDraw({
            eventId: event.data.id,
            drawId,
            isChildDraw: true,
        }));
        setUnsavedModal({ showModal: false });
    };

    const openDrawInEditor = async (draw) => {
        setSelectedRound(0);
        dispatch(drawEditActions.setSelected([]));
        dispatch(drawEditActions.setSelectedTeams([]));
        history.replace({
            search: `?v=drawEditor&d=${draw.id}`,
        });
        const hasParentDraw = !!draw.parentDrawId;
        if (hasParentDraw) {
            await dispatch(drawEditActions.getDraw({ eventId: event.data.id, drawId: draw.parentDrawId, dontAutoLoadFirstChildDraw: true }));
            await dispatch(drawEditActions.getDraw({ eventId: event.data.id, drawId: draw.id, isChildDraw: true }));
        } else {
            await dispatch(drawEditActions.getDraw({
                eventId: event.data.id,
                drawId: draw.id,
                setAsCurrentDraw: true,
            }));
        }
        setActiveView('drawEditor');
        setUnsavedModal({ showModal: false });
    };

    const handlePlayersTabClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        history.replace({
            search: `?v=playersTab`,
        });
        dispatch(drawEditActions.setSelected([]));
        dispatch(drawEditActions.setSelectedTeams([]));
        setActiveView('playersTab');
        setSelectedRound(0);
        setUnsavedModal({ showModal: false });
    };

    const handleScheduleTabClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        history.replace({
            search: `?v=scheduleTab`,
        });
        setActiveView('scheduleTab');
        setSelectedRound(0);
        setUnsavedModal({ showModal: false });
    };

    const handleLocationsTabClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        let search = '?v=locationsTab';
        if (locations.data?.[0]) {
            search = `?v=locationsTab&l=${locations.data?.[0].id}`;
        }
        history.replace({
            search,
        });
        setActiveView('locationsTab');
        setSelectedRound(0);
        setSelectedLocation(locations.data?.[0] || null);
        setUnsavedModal({ showModal: false });
    };

    const handleOfficialsTabClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        history.replace({
            search: `?v=officialsTab`,
        });
        setActiveView('officialsTab');
        setSelectedRound(0);
        setUnsavedModal({ showModal: false });
    };

    const handleNotificationsTabClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        history.replace({
            search: `?v=${EventDeskTabKeys.NOTIFICATIONS}`,
        });
        setActiveView(EventDeskTabKeys.NOTIFICATIONS);
        setSelectedRound(0);
        setUnsavedModal({ showModal: false });
    };

    const handleAccountsTabClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        history.replace({
            search: `?v=${EventDeskTabKeys.ACCOUNTS}`,
        });
        setActiveView(EventDeskTabKeys.ACCOUNTS);
        setSelectedRound(0);
        setUnsavedModal({ showModal: false });
    };

    const handlePrintSpoolerTabClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        history.replace({
            search: `?v=${EventDeskTabKeys.PRINT_SPOOLER}`,
        });
        setActiveView(EventDeskTabKeys.PRINT_SPOOLER);
        setSelectedRound(0);
        setUnsavedModal({ showModal: false });
    };

    const handleCheckInTabClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        history.replace({
            search: `?v=checkInTab`,
        });
        dispatch(drawEditActions.setSelected([]));
        dispatch(drawEditActions.setSelectedTeams([]));
        setActiveView('checkInTab');
        setSelectedRound(0);
        setUnsavedModal({ showModal: false });
    };

    const checkDrawUnsavedChanges = (callback, text) => {
        if (activeView === 'drawEditor' && currentDraw.unsavedChanges) {
            setUnsavedModal({ showModal: true, callback, text });
        } else if (callback) {
            callback();
        } else {
            // Not need to be handled
        }
    };

    const { guardAction: guardUnpublishedChanges } = useCourtSchedularUnpublishedChangesGuard();

    const checkAllUnsavedChanges = (callback, text) => {
        checkDrawUnsavedChanges(() => {
            if (activeView === EventDeskTabKeys.COURT_SCHEDULER) {
                guardUnpublishedChanges(callback);
            } else {
                callback();
            }
        }, text);
    };

    const handleDiscardChanges = () => {
        dispatch(drawEditActions.setResetTimer(true));
        dispatch(drawEditActions.reloadDraw());
        setUnsavedModal({ showModal: false });
    };

    const addToMatch = ({ roundIndex, matchId, position, player }) => {
        dispatch(drawEditActions.addToMatch({ roundIndex, matchId, position, player }));
    };

    // DRAWS

    const showPublishModal = async () => {
        dispatch(drawEditActions.setResetTimer(true));
        const publishedDrawIds = draws.data.map(d => {
            if (d.published) {
                return d.id;
            }
            return false;
        }).filter(item => item);
        setDrawsDropDown(prevState => {
            return {
                groups: prevState.groups.map((dateGroup) => {
                    return {
                        ...dateGroup,
                        selected: false,
                        isOpen: false,
                        draws: dateGroup.draws.map((draw) => {
                            return {
                                ...draw,
                                selected: false,
                            };
                        }),
                    };
                }),
                allSelected: false,
            };
        });
        await dispatch(drawEditActions.getDrawsPublishInfo(match.params.eventId));
        setPublish({ ...publish, selected: publishedDrawIds, showModal: true });
    };

    const toggleDrawPublish = (draw) => {
        dispatch(drawEditActions.setResetTimer(true));
        let selected = publish.selected || [];

        if (selected.includes(draw.id)) {
            if (!((draw.hasResults || draw.childDraws?.some(cd => cd.hasResults)) && draw.published)) {
                selected = selected.filter(drawId => drawId !== draw.id);
            }
        } else {
            selected.push(draw.id);
        }

        setPublish({ ...publish, selected });
    };

    const handlePublishDrawsClick = async () => {
        setConfirmation(false);
        dispatch(drawEditActions.setResetTimer(true));
        const draws = isScheduleDrawsEnabled
            ? drawsDropDown.groups.flatMap(group => group.draws.filter(draw => draw.selected).map(draw => draw.id))
            : publish.selected;
        await dispatch(drawEditActions.publishDraws(draws));
        history.push({ pathname: `/events/${event.data?.id}`, search: `?t=1` });
    };

    const handleCreateDrawSubmit = async ({ values, createEmptyDraw }) => {
        dispatch(drawEditActions.setResetTimer(true));
        dispatch(drawEditActions.setSavingFlag(true));
        setDrawCreateModal({ ...drawCreateModal, submitting: true });
        if (createEmptyDraw) {
            // create new empty draw (no players or teams added)
            await dispatch(drawEditActions.createDraw({ eventId: event.data.id, payload: values }));
            dispatch(drawEditActions.setSavingFlag(false));
        } else {
            // create new draw and move/copy players/teams
            // the players and teams selected for moving are already stored in redux
            if (currentDraw.unsavedChanges) {
                await dispatch(drawEditActions.saveDrawUpdates({}));
            }
            await dispatch(drawEditActions.movePlayers({ eventId: event.data.id, newDraw: values, isCopy: move.copy || preventSelectMove }));
            setMove({ showModal: false });
        }
        setActiveView('drawEditor');
        setDrawCreateModal({ showModal: false });
        dispatch(drawEditActions.setSavingFlag(false));
    };

    const handleDrawEditSubmit = async ({ values }) => {
        const formValues = {
            ...values,
        };
        const selectedPlayers = players.data.filter(player => membersInDraw.includes(player.memberId));
        const selectedTeams = teams.data.filter(team => teamsInDraw.includes(team.id));
        selectedTeams.forEach(team => {
            if (playersDictByMemberId[team.members[0]]) {
                selectedPlayers.push(playersDictByMemberId[team.members[0]]);
            }
            if (playersDictByMemberId[team.members[1]]) {
                selectedPlayers.push(playersDictByMemberId[team.members[1]]);
            }
        });

        if (formValues.ballTypeId == ballTypeIds.YELLOW) {
            formValues.ballTypeId = null;
        }
        if (formValues.formatTypeId === divisionFormatTypeIds.DINGLES) {
            formValues.isRated = false;
        }

        await dispatch(drawEditActions.updateDraw({ payload: formValues }));
        setDrawEditModal({ showModal: false, draw: null, parentDraw: null });
        setSelectedRound(0);
    };

    // MODALS

    const showDrawCreateModal = () => {
        dispatch(drawEditActions.setResetTimer(true));
        setUnsavedModal({ showModal: false });
        setDrawCreateModal({ showModal: true });
    };

    const showDrawEditModal = () => {
        handleDrawEditClick(draw, parentDraw?.data);
    };

    const showMessagePopUp = (eventId, draw) => {
        let title;
        let subTitle;
        let placeHolder;
        if (draw?.id) {
            title = `Message players in ${draw.name} Draw`;
            subTitle = 'Send an email update to all players registered in this draw.';
            placeHolder = 'Type message to include in email to all players in this draw.';
        } else {
            title = `Message all players`;
            subTitle = 'Send an email update to all players registered in the event.';
            placeHolder = 'Type message to include in email to all players.';
        }
        setMessage({
            showModal: true,
            title,
            subTitle,
            placeholder: placeHolder,
            ctaText: 'Send Message',
            eventId,
            drawId: draw ? draw.id : null,
        });
    };

    const closeMessagePopUp = () => {
        setMessage({
            showModal: false,
            title: null,
            subTitle: null,
            placeholder: null,
            ctaText: null,
            eventId: null,
            drawId: null,
        });
    };

    const toggleCreateDrawWelcomePopUp = () => {
        setDrawCreateWelcomeModal({ showModal: !drawCreateWelcomeModal.showModal });
    };

    const closeModals = () => {
        dispatch(drawEditActions.setResetTimer(true));
        if (move.showCreateAutomated) {
            // reset auto selection for automated draw creation
            dispatch(drawEditActions.setSelected([]));
            dispatch(drawEditActions.setSelectedTeams([]));
        }
        setMove({ ...move, showModal: false });
        setAutofill({ ...autofill, showModal: false });
        setAutofillRatingWarning({ ...autofillRatingWarning, showModal: false });
        setPublish({ ...publish, showModal: false });
        setDrawEditModal({ ...drawEditModal, showModal: false, draw: null, parentDraw: null });
        setDrawCreateModal({ showModal: false });
        setUnsavedModal({ showModal: false });
        setPostScore({ showModal: false });
    };

    const updateSelectedRound = (direction, arrLength = 0) => {
        dispatch(drawEditActions.setResetTimer(true));
        if (selectedRound > 0 && direction === 'down') {
            setSelectedRound(selectedRound - 1);
        } else if (selectedRound < arrLength - 2 && direction === 'up') {
            setSelectedRound(selectedRound + 1);
        } else {
            // Not need to be handled
        }
    };

    const toggleDrawsNav = () => {
        setDrawsNav({ ...drawsNav, open: !drawsNav.open });
    };

    const resetDrawListFilter = () => {
        setDrawListFilter('');
    };

    const showUnsavedError = () => {
        dispatch(showErrorPopup({
            title: 'Unsaved changes!',
            message: 'You have unsaved player placement changes. Please save your changes first.',
        }));
    };

    const handlePostScore = (roundIndex, matchIndex) => {
        if (currentDraw.unsavedChanges) {
            showUnsavedError();
        } else {
            setPostScore({
                showModal: true,
                roundIndex,
                matchIndex,
            });
        }
    };

    const toPrintPage = () => {
        if (currentDraw.data?.id) {
            if (window) {
                window.open(`/events/${event.data?.id}/draws/${currentDraw.data.id}/print`, '_blank');
            } else {
                history.push(`/events/${event.data?.id}/draws/${currentDraw.data.id}/print`);
            }
        }
    };

    const toMedalReportPrintPage = () => {
        if (currentDraw.data?.id) {
            if (window) {
                window.open(`/events/${event.data?.id}/draws/${currentDraw.data.id}/print-medal`, '_blank');
            } else {
                history.push(`/events/${event.data?.id}/draws/${currentDraw.data.id}/print-medal`);
            }
        }
    };

    const toSchedulePage = () => {
        if (window) {
            window.open(`/events/${event.data?.id}/matchsheet`, '_blank');
        } else {
            history.push(`/events/${event.data?.id}/matchsheet`);
        }
    };

    const handleLocationSelect = (e, id) => {
        e.stopPropagation();
        setSelectedLocation(locations.data?.find(l => l.id === id));
    };

    const updateSelectedFacility = (dir) => {
        setSelectedFacility(dir === 'up' ? selectedFacility + 1 : selectedFacility - 1);
    };

    const sendMessageToUser = async (recipient) => {
        dispatch(setNewConv(true));
        dispatch(addRecepient({ member: recipient }));
        history.push(`/inbox`);
    };

    const closeScheduleModal = (ev) => {
        if (ev) {
            ev.preventDefault();
            ev.stopPropagation();
        }

        setDisplayScheduleModal(false);
        setScheduleDrawDateToDisplay(null);
    };

    // RENDER -----------------------------------------------------------------------------------------

    let draw = {};

    let available;
    let description;

    let drawName;
    let drawCatType;
    let membersInTeams = [];
    const isGroupDraw = parentDraw.data?.categoryTypeId === drawCategoryTypeIds.GROUPED;
    const noDrawsYet = draws.data && !draws.data.length;

    if (activeView === EventDeskTabKeys.PLAYERS_TAB) { // v3 players tab
        drawName = 'Players';
    } else if (activeView === 'scheduleTab') {
        drawName = 'Schedule';
    } else if (activeView === 'locationsTab') {
        drawName = 'Locations/Courts';
        drawCatType = selectedLocation?.name;
    } else if (activeView === 'officialsTab') {
        drawName = 'Officials';
    } else if (activeView === EventDeskTabKeys.NOTIFICATIONS) {
        drawName = 'Notifications';
    } else if (activeView === EventDeskTabKeys.CHECK_IN) {
        drawName = 'Check In';
    } else if (activeView === EventDeskTabKeys.ACCOUNTS) {
        drawName = 'MANAGE ACCOUNTS';
    } else if (activeView === EventDeskTabKeys.PRINT_SPOOLER) {
        drawName = 'PRINT SPOOLER';
    } else if (activeView === 'drawEditor' && currentDraw.data) {
        draw = currentDraw.data;
        if (draw) {
            if (isGroupDraw) {
                drawName = parentDraw.data?.name;
                drawCatType = draw.name;
            } else {
                drawName = draw.name;
                drawCatType = getLabelByTypeId(drawCategoryTypes, draw.categoryTypeId);
            }

            if (isDoublesFormat(draw.formatTypeId)) {
                membersInTeams = getMembersInTeams(teamsInDraw, teamsDict);
            }

            if (draw.eliminationTypeId === drawEliminationTypeIds.AD_HOC || draw.eliminationTypeId === drawEliminationTypeIds.MATCH_PLAY || draw.eliminationTypeId === drawEliminationTypeIds.ROUND_ROBIN) {
                available = players.data?.filter(player => membersInDraw?.includes(player.memberId) || membersInTeams?.includes(player.memberId));
            } else {
                available = players.data?.filter(player => membersInDraw?.includes(player.memberId));
            }
            let date;
            if (draw.startDateTimeUtc) {
                date = moment.utc(draw.startDateTimeUtc).tz(timeZone.value).format('MMMM D, h:mma');
            }

            description = [
                getLabelByTypeId(formatTypes, draw.formatTypeId),
                ...(date ? [date] : []),
                getLabelByTypeId(drawEliminationTypes, draw.eliminationTypeId, parentDraw.data?.ficFormatTypeId),
                getLabelByTypeId(genderTypes, draw.genderId), getLabelByTypeId(scoringTypes, draw.scoringTypeId),
                ...(draw.isTimeBased ? ['Time Based'] : []),
                `${draw.drawSize} ${isSinglesFormat(draw.formatTypeId) ? 'Players' : 'Teams'}`,
                draw.utrRange,
                parseInt(draw.ballTypeId) >= 0 ? ballTypes.find(b => b.id === draw.ballTypeId)?.label : draw.utrRange,
                draw.ageRange,
            ].filter((val) => val).join(', ');
        }
    } else {
        // Not need to be handled
    }

    const isCutOffRound = (roundIndex) => {
        if (draw.eliminationTypeId === drawEliminationTypeIds.FEED_IN_BACK_DRAW) {
            return false;
        }

        return draw.feedOutRound && roundIndex + 1 > draw.feedOutRound;
    };
    const disableNextButton = () => {
        const isMaxRoundDisplayed = selectedRound === draw.rounds.length - 2;
        const isMaxFeedOutRoundDisplayed = draw.feedOutRound && selectedRound === draw.feedOutRound - 2;

        if (draw.eliminationTypeId === drawEliminationTypeIds.FEED_IN_BACK_DRAW) {
            return isMaxRoundDisplayed;
        }

        return isMaxRoundDisplayed || isMaxFeedOutRoundDisplayed;
    };

    const hasCrossedMaxPostScoreDate = event.data?.eventSchedule?.maxPostScoreDateUtc && moment.utc().isAfter(moment(event.data?.eventSchedule?.maxPostScoreDateUtc));

    const facilities = [];
    if (selectedLocation) {
        selectedLocation.facilities.forEach(facility => {
            // only show facilities with courts
            if (facility.courts.length) {
                facilities.push(facility);
            }
        });
    }

    const shouldDisplayHeader = activeView !== EventDeskTabKeys.COURT_SCHEDULER &&
        activeView !== EventDeskTabKeys.DAY_PLANNER &&
        activeView !== EventDeskTabKeys.NEXT_AVAILABLE &&
        activeView !== EventDeskTabKeys.MANAGE_SCHEDULE &&
        activeView !== EventDeskTabKeys.PLAYERS_TAB &&
        activeView !== EventDeskTabKeys.NOTIFICATIONS;
    const shouldContentOccupyFullScreen = activeView === EventDeskTabKeys.COURT_SCHEDULER ||
        activeView === EventDeskTabKeys.DAY_PLANNER ||
        activeView === EventDeskTabKeys.NEXT_AVAILABLE ||
        activeView === EventDeskTabKeys.MANAGE_SCHEDULE ||
        activeView === EventDeskTabKeys.PLAYERS_TAB ||
        activeView === EventDeskTabKeys.NOTIFICATIONS;

    const eventHasScheduleType = !!event.data?.scheduleTypeId;

    const getAvailablePlayersForDraw = (selectedRound) => { // updated
        return getAvailablePlayersForDrawV2(draw, selectedRound, players.data || [], membersInDraw || []);
    };

    const getAvailableTeamsForDraw = (selectedRound) => { // updated
        if (isDoublesFormat(draw.formatTypeId)) {
            return getAvailableTeamsForDrawV2(draw, selectedRound, teams.data, teamsInDraw || [], teamsDict);
        }
        return [];
    };

    const showAutofillModal = (drawId, roundId, checkRatingsDiff) => {
        dispatch(drawEditActions.setResetTimer(true));
        const selectedPlayers = players.data?.filter(player => membersInDraw?.includes(player.memberId) && !membersInWaitlist?.includes(player.memberId));
        const selectedTeams = teams.data?.filter(team => teamsInDraw?.includes(team.id) && !teamsInWaitlist?.includes(team.id));

        const showAutofillRatingWarning = checkRatingsDiff &&
            isTennisSportTypeEvent(sportTypeId) &&
            isSinglesFormat(draw.formatTypeId) &&
            draw.eliminationTypeId !== drawEliminationTypeIds.MATCH_PLAY &&
            doesPlayersHaveUtrDiff(selectedPlayers, maxUtrRatingDiffInDraw);

        if (showAutofillRatingWarning) {
            setAutofillRatingWarning({
                ...autofillRatingWarning,
                showModal: true,
                drawId,
                roundId,
            });
        } else {
            setAutofill({
                ...autofill,
                showModal: true,
                drawId,
                roundId,
                isRoundAutoFill: !!roundId,
                selected: isSinglesFormat(draw.formatTypeId) ? selectedPlayers.map(player => player.id) : [],
                selectedTeams: isDoublesFormat(draw.formatTypeId) ? selectedTeams.map(team => team.id) : [],
            });
            setAutofillRatingWarning({
                showModal: false,
                drawId: null,
                roundId: null,
            });
        }
    };

    const movePlayers = async (newDrawType) => {
        dispatch(drawEditActions.setResetTimer(true));
        const { toDrawId, copy } = move;

        if (toDrawId === 'newDraw') {
            // show draw create form
            setMove({
                ...move,
                toDrawId: null,
                forceDoubles: !!selectedTeamsLength,
                showCreateForm: newDrawType === 'manual',
                showCreateAutomated: newDrawType === 'automated',
            });
        } else {
            setMove({
                ...move,
                isSaving: true,
            });
            if (currentDraw.unsavedChanges) {
                await dispatch(drawEditActions.saveDrawUpdates({}));
            }
            await dispatch(drawEditActions.movePlayers({ toDrawId, isCopy: copy || preventSelectMove }));
            setMove({
                showModal: false,
                fromDrawId: null,
                toDrawId: null,
                isSaving: true,
            });
            setActiveView('drawEditor');
        }
    };

    const getDrawsForMoving = () => {
        const drawsForMoving = [];
        // filtering draws for associated player divisions
        const selectedPlayerDivisions = [];
        const selectedTeamDivisions = [];
        selected.forEach(memberId => {
            // eslint-disable-next-line no-unused-expressions
            playersDictByMemberId[memberId]?.divisions?.forEach(division => {
                if (!selectedPlayerDivisions.includes(division.id)) {
                    selectedPlayerDivisions.push(division.id);
                }
            });
        });
        selectedTeams.forEach(teamId => {
            // eslint-disable-next-line no-unused-expressions
            teamsDict[teamId]?.divisions?.forEach(division => {
                if (!selectedTeamDivisions.includes(division.id)) {
                    selectedTeamDivisions.push(division.id);
                }
            });
        });
        const associatedDraws = [];
        if (event.data?.divisionDrawAssociation && drawDivision) {
            Object.entries(drawDivision).forEach(([drawId, divisionIds]) => {
                if (divisionIds.some(divId => selectedPlayerDivisions.includes(divId) || selectedTeamDivisions.includes(divId))) {
                    associatedDraws.push(drawId);
                }
            });
        }
        // filtering draws for associated player divisions -- end
        draws.data.forEach(d => {
            const canMoveToDraw = event.data?.divisionDrawAssociation ? d.id !== move.fromDrawId && associatedDraws.includes(d.id) : !(d.id === move.fromDrawId || (selectedTeamsLength && d.formatTypeId === divisionFormatTypeIds.SINGLES));
            if (canMoveToDraw) {
                if (d.cagetoryTypeId === drawCategoryTypeIds.GROUPED) {
                    d.childDraws.forEach(cd => {
                        drawsForMoving.push({
                            ...cd,
                            name: `${d.name} - ${cd.name}`,
                        });
                    });
                } else if (d.categoryTypeId === drawCategoryTypeIds.PRO_DRAW) {
                    drawsForMoving.push({
                        ...d,
                        name: `${d.name} - ${getDrawName(d, d, drawCategoryTypesDict)}`,
                    });
                    d.childDraws
                        .filter(cd => cd.categoryTypeId === drawCategoryTypeIds.PRO_DRAW_QUALIFIER)
                        .forEach(cd => {
                            drawsForMoving.push({
                                ...cd,
                                name: `${d.name} - ${cd.name}`,
                            });
                        });
                } else {
                    drawsForMoving.push(d);
                }
            }
        });
        return drawsForMoving;
    };

    const handleAutomatedDrawSubmit = async (values) => {
        dispatch(drawEditActions.setResetTimer(true));
        const { name, eliminationTypeId, autofillTypeId, matchesGuaranteed, groupsCount, ...otherValues } = values;

        const submitData = {
            name,
            eliminationTypeId,
            autofillTypeId,
            ...otherValues,
            ...(parseInt(autofillTypeId) === drawAutofillTypeIds.LEVEL_BASED ? { matchesGuaranteed } : {}),
            ...(parseInt(autofillTypeId) === drawAutofillTypeIds.SNAKE || parseInt(autofillTypeId) === drawAutofillTypeIds.SEEDED ? { groupsCount } : {}),
        };

        dispatch(drawEditActions.createAutomatedDraw(submitData)).then(() => {
            setSelectedRound(0);
            closeModals();
            setActiveView('drawEditor');
        });
    };

    const toggleDrawCreateForm = () => {
        dispatch(drawEditActions.setResetTimer(true));
        setMove({
            ...move,
            showCreateForm: !move.showCreateForm,
            showCreateAutomated: !move.showCreateAutomated,
            backToAutomated: move.showCreateAutomated,
        });
    };

    const hideCreateDrawForm = () => {
        dispatch(drawEditActions.setResetTimer(true));
        setMove({
            ...move,
            showCreateForm: false,
            showCreateAutomated: false,
        });
    };

    const moveOption = (toDrawId) => {
        if (toDrawId === 'copy') {
            setMove({ ...move, copy: !move.copy });
        } else {
            setMove({ ...move, toDrawId });
        }
    };

    const handleCourtScheduleTabClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        history.replace({
            search: `?v=${EventDeskTabKeys.COURT_SCHEDULER}`,
        });
        setActiveView(EventDeskTabKeys.COURT_SCHEDULER);
        setSelectedRound(0);
        setUnsavedModal({ showModal: false });
    };

    const handleDayPlannerTabClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        history.replace({
            search: `?v=${EventDeskTabKeys.DAY_PLANNER}`,
        });
        setActiveView(EventDeskTabKeys.DAY_PLANNER);
        setSelectedRound(0);
        setUnsavedModal({ showModal: false });
    };

    const handleDrawDivisionAssociationAccept = () => {
        dispatch(drawEditActions.confirmDivisionDrawAssociation());
        setShowDrawDivisionAssociationPopup(false);
    };

    const handleFailedMemberConfirm = () => {
        dispatch(drawEditActions.setMoveFailedPlayers([]));
    };

    const handleNextAvailableTabClick = () => {
        dispatch(drawEditActions.setResetTimer(true));
        history.replace({
            search: `?v=${EventDeskTabKeys.NEXT_AVAILABLE}`,
        });
        setActiveView(EventDeskTabKeys.NEXT_AVAILABLE);
        setSelectedRound(0);
        setUnsavedModal({ showModal: false });
    };

    const drawDivisionAssociationPopup = () => {
        return (
            <ConfirmActionPopup
                confirmationTitle={`Confirm settings for division/draw association`}
                confirmationMessage={(
                    <>
                        You have set up the event to require that registration divisions are associated with draws.
                        <br /><br />
                        This means draws can only include players registered in divisions with the same gender and game type.
                        <br /><br />
                        Note: You can adjust event settings in step 2 of the edit event process.
                        <br /><br />
                        Would you like to continue?
                    </>
                )}
                confirmButtonLabel={`Yes`}
                onCloseClick={() => {
                    history.push(`/events/${match.params.eventId}/edit?step=2`);
                }}
                onCtaClick={handleDrawDivisionAssociationAccept}
            />
        );
    };

    const handleScheduleDrawDateChange = () => (dateTime) => {
        let updatedTime = dateTime ? moment.utc(dateTime).tz(event?.data?.eventSchedule?.timeZone?.value) : null;
        if (updatedTime?.isBefore(moment.utc().tz(event?.data?.eventSchedule?.timeZone?.value))) {
            updatedTime = moment.utc().tz(event?.data?.eventSchedule?.timeZone?.value);
        }
        setScheduleDrawDateToDisplay(updatedTime);
    };

    const onScheduleDrawDateFormSubmit = async () => {
        setShowConfirmSchedulePublishDraw(true);
    };

    const handleScheduleDrawDropdownState = (group) => {
        setDrawsDropDown(prevState => {
            return {
                ...prevState,
                groups: prevState.groups.map((dateGroup) => {
                    if (dateGroup.date === group.date) {
                        return {
                            ...dateGroup,
                            isOpen: !dateGroup.isOpen,
                        };
                    }
                    return dateGroup;
                }),
            };
        });
    };

    const handleScheduleDrawSelectedState = (group, selection) => {
        setDrawsDropDown(prevState => {
            return {
                ...prevState,
                groups: prevState.groups.map((dateGroup) => {
                    if (dateGroup.date === group.date) {
                        return {
                            ...dateGroup,
                            draws: dateGroup.draws.map((draw) => {
                                if (draw.id === selection.id) {
                                    return {
                                        ...draw,
                                        selected: !draw.selected,
                                    };
                                }
                                return draw;
                            }),
                        };
                    }
                    return dateGroup;
                }),
            };
        });
    };

    const handleScheduleDrawSelectedStateGroup = (group) => {
        setDrawsDropDown(prevState => {
            return {
                ...prevState,
                groups: prevState.groups.map((dateGroup) => {
                    if (dateGroup.date === group.date) {
                        return {
                            ...dateGroup,
                            selected: !dateGroup.selected,
                            isOpen: true,
                            draws: dateGroup.draws.map((draw) => {
                                return {
                                    ...draw,
                                    // only toggle selected state for draws that are not disabled
                                    ...(!draw.disabled ? { selected: !dateGroup.selected } : {}),
                                };
                            }),
                        };
                    }
                    return dateGroup;
                }),
            };
        });
    };

    const handleScheduleDrawSelectedStateAll = () => {
        setDrawsDropDown(prevState => {
            return {
                groups: prevState.groups.map((dateGroup) => {
                    return {
                        ...dateGroup,
                        // only toggle selected state for groups that are not disabled
                        ...(!dateGroup.disabled ? { selected: !prevState.allSelected } : {}),
                        isOpen: true,
                        draws: dateGroup.draws.map((draw) => {
                            return {
                                ...draw,
                                // only toggle selected state for draws that are not disabled
                                ...(!draw.disabled ? { selected: !prevState.allSelected } : {}),
                            };
                        }),
                    };
                }),
                allSelected: !prevState.allSelected,
            };
        });
    };

    const handleRemoveScheduled = (scheduled, type = 'draw') => {
        let drawsToCancel = [];
        if (type === 'group') {
            drawsToCancel = scheduled.draws.filter(draw => (!draw.published && draw.publishScheduled)).map(draw => draw.id);
        } else {
            drawsToCancel = [scheduled.id];
        }
        setDrawsScheduledToCancel(drawsToCancel);
        setShowConfirmDeleteScheduledDraw(true);
    };

    const handleRemoveScheduledConfirm = () => {
        dispatch(drawEditActions.deleteScheduledAutoPublishDraws(event.data.id, drawsScheduledToCancel));
        setShowConfirmDeleteScheduledDraw(false);
    };

    const handleSchedulePublishConfirm = () => {
        setDisplayScheduleModal(false);
        const drawIds = drawsDropDown.groups.flatMap(group => group.draws.filter(draw => (draw.selected && !draw.published)).map(draw => draw.id));
        dispatch(drawEditActions.scheduleAutoPublishDraws(event.data?.id, { drawIds, scheduledTime: moment.utc(scheduleDrawDateToDisplay)?.toISOString() }));
        setShowConfirmSchedulePublishDraw(false);
        setPublish({ ...publish, showModal: true });
        setScheduleDrawDateToDisplay(null);
    };

    const allowMomentTimeZoneOverride = useMemo(() => {
        if (activeView === EventDeskTabKeys.COURT_SCHEDULER) {
            return !(courtScheduler.selectedDate && courtScheduler.selectedDateCourtConfig);
        }

        if (activeView === EventDeskTabKeys.DAY_PLANNER) {
            return !(dayPlanner?.viewState?.day && dayPlanner?.dayConfig);
        }

        return true;
    }, [activeView, courtScheduler.selectedDate, courtScheduler.selectedDateCourtConfig, dayPlanner?.viewState?.day, dayPlanner?.dayConfig]);

    if (event.data && draws.data && players.data && teams.data && event.data?.memberEventDirectorRoleId === directorRoleIds.VOLUNTEER && !isCurrentMemberAdmin) {
        return (
            <div className={`${styles.section} bg-transparent ${shouldContentOccupyFullScreen ? styles.fullscreen : ''} ${styles.sidebarv3}`}>
                <div className={styles.sideBar}>
                    <div className={`${styles.buttonWrapper} ${activeView === 'checkInTab' ? 'active' : ''}`} onClick={() => checkAllUnsavedChanges(() => handleCheckInTabClick())} data-testid="draw-edit.volunteer-sidebar.check-in-btn">
                        <div className={styles.button}>
                            <Img className="close-icon" src={`/img/v3/icons/icon-check-in-24px${activeView === 'checkInTab' ? '-white' : ''}.svg`} />
                        </div>
                        <div className={styles.label} data-testid="draw-edit.volunteer-sidebar.check-in-label">
                            Check in
                        </div>
                    </div>
                </div>
                {shouldDisplayHeader && (
                    <DrawsHeaderV2
                        isReadOnly={isReadOnly}
                        isLocked={isLocked}
                        handleEditClick={() => setIsReadOnly(false)}
                        drawName={drawName}
                        eventName={eventName}
                        drawCatType={drawCatType}
                        showDrawEditModal={() => checkDrawUnsavedChanges(() => showDrawEditModal())}
                        toPrintPage={toPrintPage}
                        toMedalReportPrintPage={toMedalReportPrintPage}
                        toSchedulePage={toSchedulePage}
                        showMessagePopUp={showMessagePopUp}
                        eventId={match.params.eventId}
                        draw={draw}
                        description={description}
                        handleSaveClick={handleSaveClick}
                        showPublishModal={showPublishModal}
                        closeClickHandler={closeClickHandler}
                        locations={locations.data}
                        parentDraw={parentDraw?.data}
                        activeView={activeView}
                        PTTError={PTTError}
                        showErrorPopup={showErrorPopup}
                        unsavedChanges={currentDraw.unsavedChanges}
                        handleDiscardChanges={() => checkDrawUnsavedChanges(() => handleDiscardChanges(), 'Discard changes?')}
                        noDrawsYet={noDrawsYet}
                        sportTypeId={sportTypeId}
                        hideNavBar={activeView === EventDeskTabKeys.CHECK_IN || activeView === EventDeskTabKeys.ACCOUNTS}
                        containerClass={activeView === EventDeskTabKeys.CHECK_IN ? 'check-in-container' : ''}
                    />
                )}
                {activeView === EventDeskTabKeys.CHECK_IN && players.data && (
                    <CheckInTab
                        eventId={match.params.eventId}
                        divisions={event.data?.eventDivisions || []}
                        utrType={utrType}
                        sportTypeId={sportTypeId}
                        showHighSchoolName={isOfficialHSEvent}
                    />
                )}
            </div>
        );
    }
    if (event.data && draws.data && players.data && teams.data) {
        if (!eventHasScheduleType) {
            return (
                <div
                    className={`${styles.section} bg-transparent ${styles.fullscreen}`}
                >
                    <DrawsHeaderV2
                        isReadOnly={isReadOnly}
                        isLocked={isLocked}
                        eventId={match.params.eventId}
                        closeClickHandler={closeClickHandler}
                        locations={locations.data}
                        sportTypeId={sportTypeId}
                        draw={{}}
                        noDrawsYet
                        occupyFullWidth
                        eventName={eventName}
                        containerClass={activeView === EventDeskTabKeys.CHECK_IN ? 'check-in-container' : ''}
                    />
                    <EventScheduleTypeSelection />
                    {showDrawDivisionAssociationPopup && (
                        <>{drawDivisionAssociationPopup()}</>
                    )}
                </div>
            );
        }

        const moveButtonLabel = move.copy || preventSelectMove ? 'ADD' : 'MOVE';

        return (
            <div className={`${styles.section} bg-transparent ${shouldContentOccupyFullScreen ? styles.fullscreen : ''} ${styles.sidebarv3}`}>
                <DrawsSidebarLeftV3
                    isReadOnly={isReadOnly}
                    drawsNav={drawsNav}
                    toggleDrawsNav={toggleDrawsNav}
                    drawListFilter={drawListFilter}
                    setDrawListFilter={e => setDrawListFilter(e.target.value)}
                    resetDrawListFilter={resetDrawListFilter}
                    showDrawCreateModal={() => checkAllUnsavedChanges(() => showDrawCreateModal())}
                    currentDraw={currentDraw.data}
                    parentDraw={parentDraw.data}
                    event={event.data}
                    // v3 players tab
                    handlePlayersTabClick={() => checkAllUnsavedChanges(() => handlePlayersTabClick())}
                    handleDrawTabClick={(drawId) => checkAllUnsavedChanges(() => handleDrawTabClick(drawId))}
                    handleDrawDeleteClick={(drawId) => checkAllUnsavedChanges(() => handleDrawDeleteClick(drawId))}
                    handleDrawEditClick={(draw, parentDraw) => checkAllUnsavedChanges(() => handleDrawEditClick(draw, parentDraw))}
                    handleChildDrawClick={(e, drawId) => checkAllUnsavedChanges(() => handleChildDrawClick(e, drawId))}
                    handleScheduleTabClick={() => checkAllUnsavedChanges(() => handleScheduleTabClick())}
                    handleLocationsTabClick={() => checkAllUnsavedChanges(() => handleLocationsTabClick())}
                    handleOfficialsTabClick={() => checkAllUnsavedChanges(() => handleOfficialsTabClick())}
                    handleNotificationsTabClick={() => checkAllUnsavedChanges(() => handleNotificationsTabClick())}
                    handleAccountsTabClick={() => checkAllUnsavedChanges(() => handleAccountsTabClick())}
                    handlePrintSpoolerTabClick={() => checkAllUnsavedChanges(() => handlePrintSpoolerTabClick())}
                    handleCheckInTabClick={() => checkAllUnsavedChanges(() => handleCheckInTabClick())}
                    activeView={activeView}
                    selectedLocation={selectedLocation}
                    handleLocationSelect={handleLocationSelect}
                    scheduleTypeId={scheduleTypeId}
                    handleCourtScheduleTabClick={() => checkAllUnsavedChanges(() => handleCourtScheduleTabClick())}
                    handleDayPlannerTabClick={() => checkAllUnsavedChanges(() => handleDayPlannerTabClick())}
                    handleNextAvailableTabClick={() => checkAllUnsavedChanges(() => handleNextAvailableTabClick())}
                />
                {shouldDisplayHeader && (
                    <DrawsHeaderV2
                        isReadOnly={isReadOnly}
                        isLocked={isLocked}
                        handleEditClick={() => setIsReadOnly(false)}
                        drawName={drawName}
                        drawCatType={drawCatType}
                        showDrawEditModal={() => checkDrawUnsavedChanges(() => showDrawEditModal())}
                        toPrintPage={toPrintPage}
                        toMedalReportPrintPage={toMedalReportPrintPage}
                        toSchedulePage={toSchedulePage}
                        showMessagePopUp={showMessagePopUp}
                        eventId={match.params.eventId}
                        draw={draw}
                        description={description}
                        handleSaveClick={handleSaveClick}
                        showPublishModal={showPublishModal}
                        closeClickHandler={closeClickHandler}
                        locations={locations.data}
                        parentDraw={parentDraw?.data}
                        activeView={activeView}
                        PTTError={PTTError}
                        showErrorPopup={showErrorPopup}
                        unsavedChanges={currentDraw.unsavedChanges}
                        handleDiscardChanges={() => checkDrawUnsavedChanges(() => handleDiscardChanges(), 'Discard changes?')}
                        noDrawsYet={noDrawsYet}
                        sportTypeId={sportTypeId}
                        eventName={eventName}
                        hideNavBar={activeView === EventDeskTabKeys.CHECK_IN || activeView === EventDeskTabKeys.ACCOUNTS}
                        containerClass={activeView === EventDeskTabKeys.CHECK_IN ? 'check-in-container' : ''}
                    />
                )}
                {activeView === 'drawEditor' && !noDrawsYet && (
                    <DrawsSubHeaderV2
                        allPlayersListFilters={allPlayersListFilters}
                        setAllPlayersListFilters={setAllPlayersListFilters}
                        currentDraw={currentDraw.data}
                        draw={draw}
                        selectedRound={selectedRound}
                        disableNextButton={disableNextButton}
                        updateSelectedRound={updateSelectedRound}
                        isCutOffRound={isCutOffRound}
                        activeView={activeView}
                    />
                )}
                {activeView === EventDeskTabKeys.PLAYERS_TAB && players.data && (
                    <PlayersTabV3
                        eventId={match.params.eventId}
                        players={players.data || []}
                        teams={teams.data || []}
                        divisions={event.data?.eventDivisions || []}
                        sendMessage={sendMessageToUser}
                        setMove={setMove}
                        utrType={utrType}
                        sportTypeId={sportTypeId}
                        showHighSchoolName={isOfficialHSEvent}
                        isFlexLeagueEvent={isFlexLeagueEvent}
                    />
                )}
                {draw && activeView === EventDeskTabKeys.MANAGE_SCHEDULE && (
                    <ScheduleTabV2 />
                )}
                {draw && activeView === 'locationsTab' && (
                    <>
                        <LocationsSubHeaderV2
                            updateSelectedFacility={updateSelectedFacility}
                            selectedFacility={selectedFacility}
                            facilities={facilities}
                            excludedCourtIds={excludedCourtIds}
                            setExcludedCourtIds={setExcludedCourtIds}
                        />
                        <LocationsTabV2
                            locationsTab={locationsTab}
                            selectedFacility={selectedFacility}
                            facilities={facilities}
                            excludedCourtIds={excludedCourtIds}
                            setExcludedCourtIds={setExcludedCourtIds}
                            history={history}
                        />
                    </>
                )}
                {draw && activeView === 'officialsTab' && (
                    <OfficialsTabV2
                        officialsTab={officialsTab}
                    />
                )}
                {draw && activeView === EventDeskTabKeys.NOTIFICATIONS && (
                    <NotificationsTab />
                )}
                {activeView === EventDeskTabKeys.CHECK_IN && players.data && (
                    <CheckInTab
                        eventId={match.params.eventId}
                        divisions={event.data?.eventDivisions || []}
                        utrType={utrType}
                        sportTypeId={sportTypeId}
                        showHighSchoolName={isOfficialHSEvent}
                    />
                )}
                {draw && activeView === 'drawEditor' && currentDraw.data && players.data && teams.data && (
                    <div className={`${styles.section} bg-transparent main-content`}>
                        <div className={`container bg-transparent`}>
                            <div className="row">
                                <div className="col-md-4">
                                    <DrawsPlayerListWrapperV2
                                        players={players.data || []}
                                        teams={teams.data || []}
                                        membersInDraw={membersInDraw}
                                        membersPlaced={membersPlaced}
                                        membersInWaitlist={membersInWaitlist}
                                        membersInTeams={membersInTeams}
                                        membersHaveResults={membersHaveResults}
                                        teamsHaveResults={teamsHaveResults}
                                        teamsInDraw={teamsInDraw}
                                        teamsPlaced={teamsPlaced}
                                        teamsInWaitlist={teamsInWaitlist}
                                        available={available}
                                        isReadOnly={isReadOnly}
                                        utrType={utrType}
                                        utrTypeId={utrTypeId}
                                        handleCreateDrawSubmit={handleCreateDrawSubmit}
                                        unsavedChanges={currentDraw.unsavedChanges}
                                        isGroupDraw={isGroupDraw}
                                        autofill={autofill}
                                        setAutofill={setAutofill}
                                        autofillRatingWarning={autofillRatingWarning}
                                        setAutofillRatingWarning={setAutofillRatingWarning}
                                        showAutofillModal={showAutofillModal}
                                        move={move}
                                        setMove={setMove}
                                        sportTypeId={sportTypeId}
                                        eventId={match.params.eventId}
                                        isPTTEvent={isPTTEvent}
                                    />
                                </div>
                                <RoundsV2
                                    isReadOnly={isReadOnly}
                                    draw={draw}
                                    parentDraw={parentDraw.data}
                                    selectedRound={selectedRound}
                                    updateSelectedRound={updateSelectedRound}
                                    disableNextButton={disableNextButton}
                                    playersDict={playersDict}
                                    playersDictByMemberId={playersDictByMemberId}
                                    teamsDict={teamsDict}
                                    membersInDrawDict={membersInDrawDict}
                                    teamsInDrawDict={teamsInDrawDict}
                                    players={players.data || []}
                                    available={available}
                                    teams={teams.data || []}
                                    timeZone={timeZone}
                                    event={event}
                                    utrType={utrType}
                                    isCutOffRound={isCutOffRound}
                                    addToMatch={addToMatch}
                                    handlePostScore={handlePostScore}
                                    showAutofillModal={showAutofillModal}
                                    isPTTEvent={isPTTEvent}
                                    PTTError={PTTError}
                                    getAvailablePlayersForDraw={getAvailablePlayersForDraw}
                                    getAvailableTeamsForDraw={getAvailableTeamsForDraw}
                                    sportTypeId={sportTypeId}
                                />
                                {draw.rounds?.length === 0 && (
                                    <div className="col-md-8">
                                        <div className="curly-arrow" />
                                        <p className="text-center" data-testid="draw-edit.empty-draw.message">Your draw hasn&apos;t been initialized yet. <br />Please add your players and click <span className="clickable underline text-teal" onClick={() => showAutofillModal(draw.id, null, true)} data-testid="draw-edit.empty-draw.autofill-btn"><i className="uts uts-refresh" /> Auto-Fill</span> to get started.</p>
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>
                )}
                {activeView === 'drawEditor' && noDrawsYet && (
                    <div className="h100 d-flex aic jcc flex-col">
                        <h3 data-testid="draw-edit.welcome.title">Welcome to Event Desk</h3>
                        <div className="container mt64 bt0" style={{ borderTop: 'none' }}>
                            <div className="row">
                                {isDrawCreationAllowed && (
                                    <div className="col-12 col-md-4 offset-md-2 text-center">
                                        <p style={{ height: '100px', textAlign: 'center' }} data-testid="draw-edit.welcome.create-draw-description">You can start by creating a new empty draw</p>
                                        <button type="button" className="btn btn-default" onClick={showDrawCreateModal} data-testid="draw-edit.welcome.create-draw-btn">Create Draw</button>
                                    </div>
                                )}
                                <div className={`col-12 col-md-4 text-center ${isDrawCreationAllowed ? '' : 'offset-md-4'}`}>
                                    <p style={{ height: '100px', textAlign: 'center' }} data-testid="draw-edit.welcome.all-players-description">Or you can go to the All Players List and start creating a draw by selecting players</p>
                                    <button type="button" className="btn btn-default" onClick={handlePlayersTabClick} data-testid="draw-edit.welcome.all-players-btn">All Players List</button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {activeView === EventDeskTabKeys.COURT_SCHEDULER && (
                    <CourtSchedular
                        setEventDeskActiveView={setActiveView}
                    />
                )}
                {activeView === EventDeskTabKeys.DAY_PLANNER && (
                    <DayPlanner
                        setEventDeskActiveView={setActiveView}
                    />
                )}

                {activeView === EventDeskTabKeys.NEXT_AVAILABLE && (
                    <NextAvailable
                        openDrawInEditor={openDrawInEditor}
                    />
                )}

                {activeView === EventDeskTabKeys.ACCOUNTS && (
                    <ManageAccountsTab
                        eventId={match.params.eventId}
                        players={players.data || []}
                        teams={teams.data || []}
                        divisions={event.data?.eventDivisions || []}
                        sendMessage={sendMessageToUser}
                        setMove={setMove}
                        utrType={utrType}
                        sportTypeId={sportTypeId}
                        showHighSchoolName={isOfficialHSEvent}
                    />
                )}
                {activeView === EventDeskTabKeys.PRINT_SPOOLER && (
                    <PrintSpoolerTab eventId={match?.params?.eventId} />
                )}
                {typeof window !== 'undefined' && (
                    <div>
                        {publish.showModal && !isScheduleDrawsEnabled && (
                            <Modal visible={publish.showModal} onClickBackdrop={closeModals} dialogClassName="modal-lg">
                                <div className="modal-header">
                                    <div className="text-medium" data-testid="modal.draw-edit.publish-draws.title">Publish Draws</div>
                                    <div className="close-icon" onClick={closeModals} data-testid="modal.draw-edit.publish-draws.close-btn"><i className="utr utr-close" /></div>
                                </div>
                                <div className="modal-body">
                                    <p className="mb24" data-testid="modal.draw-edit.publish-draws.description">Select draws to publish and display publicly on the event profile page. If you unselect a draw and click &quot;Publish&quot;, that draw will be unpublished from the event profile page. <span className="text-danger" data-testid="modal.draw-edit.publish-draws.no-unpublish-warning">Draws that have scores entered, cannot be unpublished.</span></p>
                                    {draws.data?.length && draws.data.map((drw) => (
                                        <div key={drw.id} className={`checkbox checkbox-large mb24 ${publish.selected.includes(drw.id) ? 'selected' : ''}`} onClick={() => toggleDrawPublish(drw)} data-testid={`modal.draw-edit.publish-draws.draw-${drw.id}`}>
                                            <div className="checkbox-wrapper">
                                                <div className={`checkbox-check`}><Img src="/img/icons/checkmark-icon.svg" /></div>
                                            </div>
                                            <div className="label">
                                                <div className="text" data-testid={`modal.draw-edit.publish-draws.draw-${drw.id}.name`}>{drw.name}</div>
                                            </div>
                                        </div>
                                    ))}
                                    <button
                                        type="button"
                                        className={`btn btn-xl btn-block btn-primary`}
                                        onClick={() => {
                                            setConfirmation(true);
                                        }}
                                        disabled={isPublishing || isSaving || draws.loading}
                                        data-testid="modal.draw-edit.publish-draws.publish-btn"
                                    >
                                        {isPublishing && ('Publishing...')}
                                        {!isPublishing && draws.loading && ('Loading...')}
                                        {!isPublishing && !draws.loading && ('Publish')}
                                    </button>
                                </div>
                            </Modal>
                        )}
                        {publish.showModal && isScheduleDrawsEnabled && (
                            <Modal visible={publish.showModal} onClickBackdrop={closeModals} dialogClassName="modal-lg">
                                <div className="modal-header">
                                    <div className="text-medium" data-testid="modal.draw-edit.schedule-publish.title">Publish Draws</div>
                                    <div className="close-icon" onClick={closeModals} data-testid="modal.draw-edit.schedule-publish.close-btn"><i className="utr utr-close" /></div>
                                </div>
                                <div className="modal-body">
                                    <p className="mb24" data-testid="modal.draw-edit.schedule-publish.description">Select draws to publish and display publicly on the event profile page. If you unselect a draw and click &quot;Publish&quot;, that draw will be unpublished from the event profile page. <span className="text-danger" data-testid="modal.draw-edit.schedule-publish.no-unpublish-warning">Draws that have scores entered, cannot be unpublished.</span></p>
                                    <Form>
                                        <div className={styles.scheduleModalDrawsTable}>
                                            <div className={styles.scheduleModalDrawsTableHeader}>
                                                <div>
                                                    <SingleCheckbox
                                                        id="drawsAllDatesSelected"
                                                        label="Draw Date"
                                                        isChecked={drawsDropDown.allSelected}
                                                        onChange={() => handleScheduleDrawSelectedStateAll()}
                                                        darkOption
                                                        data-testid="modal.draw-edit.schedule-publish.select-all"
                                                    />
                                                </div>
                                                <div data-testid="modal.draw-edit.schedule-publish.header-schedule">
                                                    Schedule Publish
                                                </div>
                                                <div />
                                            </div>
                                            {drawsDropDown.groups.map((group, i) => {
                                                return (
                                                    <div className={styles.scheduleModalDrawsGroup} key={`${group.date}_${i}`}>
                                                        <div className="d-flex aic date">
                                                            <SingleCheckbox
                                                                id={`${group.date}_${i}`}
                                                                isChecked={group.selected}
                                                                onChange={() => handleScheduleDrawSelectedStateGroup(group)}
                                                                key={`${group.date}_${i}`}
                                                                disabled={group.disabled}
                                                                checkboxClassName={group.disabled ? styles.scheduleModalDrawsDisabledCheckbox : ''}
                                                                darkOption
                                                                data-testid={`modal.draw-edit.schedule-publish.group-${i}`}
                                                            />

                                                            <Collapsible
                                                                isOpen={group.isOpen || false}
                                                                onClick={() => handleScheduleDrawDropdownState(group)}
                                                                className={`${styles.scheduleModalDrawsCollapsible} collapsible`}
                                                                data-testid={`modal.draw-edit.schedule-publish.group-${i}.collapsible`}
                                                            >
                                                                <div className="d-flex aic">
                                                                    <div className={styles.scheduleModalDrawsCollapsibleDate} data-testid={`modal.draw-edit.schedule-publish.group-${i}.date`}>{(group.date && moment(group.date).tz(event?.data?.eventSchedule?.timeZone?.value).format('MMM DD, YYYY')) || 'No Date Assigned'}</div>
                                                                    {!group.selected && (group.publishScheduledTimeUtc || group.scheduledYetToPublishDrawsCount > 0) && (
                                                                        <div className="flex-1 d-flex">
                                                                            {group.publishScheduledTimeUtc && <div className="flex-1" data-testid={`modal.draw-edit.schedule-publish.group-${i}.scheduled-time`}>{moment.utc(group.publishScheduledTimeUtc).tz(event?.data?.eventSchedule?.timeZone?.value).format('MMM DD, YYYY hh:mmA')}</div>}
                                                                            {!group.publishScheduledTimeUtc && group.scheduledYetToPublishDrawsCount && <div className="flex-1" data-testid={`modal.draw-edit.schedule-publish.group-${i}.scheduled-count`}>{group.scheduledYetToPublishDrawsCount} Scheduled</div>}
                                                                            <img src={'/img/icons/addSponsorTierIcon.svg'} alt="remove scheduled" className={styles.scheduleModalDrawsRemoveScheduled} onClick={() => handleRemoveScheduled(group, 'group')} data-testid={`modal.draw-edit.schedule-publish.group-${i}.remove-scheduled-btn`} />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </Collapsible>
                                                        </div>
                                                        {group.isOpen && (
                                                            <div className="ml16 mb8">
                                                                {group?.draws?.map((_draw) => {
                                                                    return (
                                                                        <div className={`subrow d-flex aic`} key={_draw.id}>
                                                                            <div className={styles.scheduleModalDrawsCollapsibleSubDate}>
                                                                                <SingleCheckbox
                                                                                    id={`${group.date}_${_draw.id}`}
                                                                                    label={_draw.name}
                                                                                    isChecked={_draw.selected}
                                                                                    onChange={() => handleScheduleDrawSelectedState(group, _draw)}
                                                                                    key={_draw.id}
                                                                                    disabled={_draw.disabled}
                                                                                    darkOption
                                                                                    checkboxClassName={_draw.disabled ? styles.scheduleModalDrawsDisabledCheckbox : ''}
                                                                                    data-testid={`modal.draw-edit.schedule-publish.draw-${_draw.id}`}
                                                                                />
                                                                            </div>
                                                                            {_draw.publishScheduled && !_draw.published && <div className="flex-1" data-testid={`modal.draw-edit.schedule-publish.draw-${_draw.id}.scheduled-time`}>{moment.utc(_draw.publishScheduledTimeUtc).tz(event?.data?.eventSchedule?.timeZone?.value).format('MMM DD, YYYY hh:mmA')} <img src={'/img/icons/addSponsorTierIcon.svg'} alt="remove scheduled" className={styles.scheduleModalDrawsRemoveScheduled} onClick={() => handleRemoveScheduled(_draw, 'draw')} data-testid={`modal.draw-edit.schedule-publish.draw-${_draw.id}.remove-scheduled-btn`} /></div>}
                                                                        </div>
                                                                    );
                                                                })}
                                                            </div>

                                                        )}
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    </Form>
                                    <div className={styles.scheduleModalFooter}>
                                        <button
                                            type="button"
                                            className={`btn btn-xl btn-block btn-primary`}
                                            onClick={() => {
                                                setConfirmation(true);
                                            }}
                                            disabled={isPublishing || isSaving || draws.loading || (drawsDropDown.groups.every(group => group.draws.every(draw => !draw.selected) && (drawsDropDown.groups.flatMap(group => group.draws.filter(draw => draw.published).map(draw => draw.id)).sort().join(',') === drawsDropDown.groups.flatMap(group => group.draws.filter(draw => draw.selected).map(draw => draw.id)).sort().join(','))) || drawsDropDown.groups.some(group => group.draws.some(draw => (draw.selected && draw.publishScheduled && !draw.published)))) || (drawsDropDown.groups.flatMap(group => group.draws.filter(draw => draw.selected).map(draw => draw.id)).sort().join(',') ===
                                                drawsDropDown.groups.flatMap(group => group.draws.filter(draw => draw.published).map(draw => draw.id)).sort().join(','))}
                                            data-testid="modal.draw-edit.schedule-publish.publish-btn"
                                        >
                                            {getPublishButtonLabel(isPublishing, draws.loading)}
                                        </button>
                                        <button
                                            type="button"
                                            className={`btn btn-xl btn-block btn-default mt0`}
                                            onClick={() => {
                                                setPublish({ ...publish, showModal: false });
                                                setDisplayScheduleModal(true);
                                                setScheduleDrawDateToDisplay(moment().tz(event?.data?.eventSchedule?.timeZone?.value));
                                            }}
                                            disabled={isPublishing || isSaving || draws.loading || shouldDisableSchedulePublishButton}
                                            data-testid="modal.draw-edit.schedule-publish.schedule-btn"
                                        >
                                            SCHEDULE
                                        </button>
                                    </div>
                                </div>
                            </Modal>
                        )}
                        {isScheduleDrawsEnabled && displayScheduleModal && (
                            <Modal
                                visible={displayScheduleModal}
                                onClickBackdrop={closeScheduleModal}
                                dialogClassName="modal-lg"
                            >
                                <div className="modal-header">
                                    <div />
                                    <div className="close-icon" onClick={closeScheduleModal} data-testid="modal.draw-edit.schedule-modal.close-btn"><i className="utr utr-close" /></div>
                                </div>
                                <div className="modal-body">
                                    <Form
                                        onSubmit={onScheduleDrawDateFormSubmit}
                                    >
                                        {(formApi) => {
                                            const { submitForm } = formApi;
                                            return (
                                                <form onSubmit={submitForm} id="scheduleDrawForm" data-testid="draw-edit-page.form-1919">
                                                    <div className={styles.scheduleModalDateSelectorContainer}>
                                                        <div className={styles.scheduleModalDateSelectorBox}>
                                                            <p className="text-medium text-dark" data-testid="modal.draw-edit.schedule-modal.title">Select Date and Time to Publish Draw(s)</p>
                                                            <p className="text-small text-dark" data-testid="modal.draw-edit.schedule-modal.description">Please select a future date and time to publish.</p>
                                                            <div className={styles.datePickerWrapper}>
                                                                <DateTimePicker
                                                                    id="scheduleDrawDate"
                                                                    field="scheduleDrawDateUTC"
                                                                    dateLabel="Date"
                                                                    timeLabel="Time"
                                                                    selected={scheduleDrawDateToDisplay}
                                                                    handleDateChange={handleScheduleDrawDateChange()}
                                                                    themeV3
                                                                    defaultDate={scheduleDrawDateToDisplay}
                                                                    dateFormat={dateFormat}
                                                                    minDate={moment.utc().tz(event?.data?.eventSchedule?.timeZone?.value)}
                                                                    maxDate={moment.utc(event?.data?.eventSchedule?.eventEndUtc).tz(event?.data?.eventSchedule?.timeZone?.value)}
                                                                    data-testid="draw-edit.schedule-draw-date-date-picker"
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className={styles.scheduleModalFooter}>
                                                        <button
                                                            type="submit"
                                                            className={`btn btn-xl btn-block btn-primary`}
                                                            disabled={isPublishing || isSaving || draws.loading}
                                                            data-testid="modal.draw-edit.schedule-modal.submit-btn"
                                                        >
                                                            SCHEDULE
                                                        </button>
                                                    </div>
                                                </form>
                                            );
                                        }}
                                    </Form>
                                </div>
                            </Modal>
                        )}
                        {drawEditModal.showModal && (
                            <EventDrawCreateEditPopup
                                onCloseClick={closeModals}
                                handleSubmit={handleDrawEditSubmit}
                                sportTypeId={sportTypeId}
                                eventTypeId={event?.data?.eventTypeId}
                                submitting={isSaving}
                                isVerifiedEvent={isVerifiedEvent}
                                eventSchedule={eventSchedule}
                                timeZone={timeZone}
                                isInEditMode
                                drawToEdit={drawEditModal.draw}
                                parentDraw={drawEditModal.parentDraw}
                                eventId={match?.params?.eventId}
                                eventAllottedMatchTimes={event.data?.matchTimes}
                                divisions={event.data?.eventDivisions || []}
                                drawDivision={drawDivision}
                                associatedDivisionIds={associatedDivisionIds}
                                associatedDivisionsByDrawId={associatedDivisionsByDrawId}
                                playersDictByMemberId={playersDictByMemberId}
                                teamsDict={teamsDict}
                                divisionDrawAssociation={event?.data?.divisionDrawAssociation}
                                awardDrawMedal={event?.data?.awardDrawMedal}
                                drawsDict={draws.drawsDict}
                                allowMomentTimeZoneOverride={allowMomentTimeZoneOverride}
                            />
                        )}
                        {drawCreateModal.showModal && (
                            <EventDrawCreateEditPopup
                                onCloseClick={closeModals}
                                handleSubmit={handleCreateDrawSubmit}
                                sportTypeId={sportTypeId}
                                eventTypeId={event?.data?.eventTypeId}
                                submitting={isSaving}
                                createEmptyDraw
                                isVerifiedEvent={isVerifiedEvent}
                                eventSchedule={eventSchedule}
                                timeZone={timeZone}
                                eventId={match?.params?.eventId}
                                eventAllottedMatchTimes={event.data?.matchTimes}
                                divisions={event.data?.eventDivisions || []}
                                associatedDivisionIds={associatedDivisionIds}
                                associatedDivisionsByDrawId={associatedDivisionsByDrawId}
                                playersDictByMemberId={playersDictByMemberId}
                                teamsDict={teamsDict}
                                divisionDrawAssociation={event?.data?.divisionDrawAssociation}
                                awardDrawMedal={event?.data?.awardDrawMedal}
                                drawsDict={draws.drawsDict}
                                clubId={clubId}
                                allowMomentTimeZoneOverride={allowMomentTimeZoneOverride}
                            />
                        )}
                        {move.showModal && move.showCreateForm && (
                            <EventDrawCreateEditPopup
                                onCloseClick={move.backToAutomated ? toggleDrawCreateForm : hideCreateDrawForm}
                                handleSubmit={handleCreateDrawSubmit}
                                sportTypeId={sportTypeId}
                                eventTypeId={event?.data?.eventTypeId}
                                submitting={isSaving}
                                isVerifiedEvent={isVerifiedEvent}
                                eventSchedule={eventSchedule}
                                timeZone={timeZone}
                                forceDoubles={move.forceDoubles}
                                customSubmitText={move.copy || preventSelectMove ? 'ADD' : 'MOVE'}
                                customCancelText="Back"
                                eventId={match?.params?.eventId}
                                eventAllottedMatchTimes={event.data?.matchTimes}
                                divisions={event.data?.eventDivisions || []}
                                associatedDivisionIds={associatedDivisionIds}
                                associatedDivisionsByDrawId={associatedDivisionsByDrawId}
                                playersDictByMemberId={playersDictByMemberId}
                                teamsDict={teamsDict}
                                divisionDrawAssociation={event?.data?.divisionDrawAssociation}
                                awardDrawMedal={event?.data?.awardDrawMedal}
                                drawsDict={draws.drawsDict}
                                allowMomentTimeZoneOverride={allowMomentTimeZoneOverride}
                            />
                        )}
                        {move.showModal && move.showCreateAutomated && (
                            <AutomatedDrawCreatePopup
                                onCreateManualDraw={toggleDrawCreateForm}
                                onCloseClick={hideCreateDrawForm}
                                sportTypeId={sportTypeId}
                                eventTypeId={event?.data?.eventTypeId}
                                submitting={isSaving}
                                isVerifiedEvent={isVerifiedEvent}
                                eventSchedule={eventSchedule}
                                timeZone={timeZone}
                                forceDoubles={move.forceDoubles}
                                eventId={match?.params?.eventId}
                                eventAllottedMatchTimes={event.data?.matchTimes}
                                selectedCount={autofill?.automated ? autofill?.selectedTeams?.length || autofill?.selected?.length : selectedTeamsLength || selectedLength}
                                handleSubmit={handleAutomatedDrawSubmit}
                                isFlexLeagueClub={isFlexLeagueClub}
                                divisions={event.data?.eventDivisions || []}
                                associatedDivisionIds={associatedDivisionIds}
                                associatedDivisionsByDrawId={associatedDivisionsByDrawId}
                                playersDictByMemberId={playersDictByMemberId}
                                teamsDict={teamsDict}
                                divisionDrawAssociation={event?.data?.divisionDrawAssociation}
                                awardDrawMedal={event?.data?.awardDrawMedal}
                                allowMomentTimezoneOverride={allowMomentTimeZoneOverride}
                                isHomeCourtQuestionRequired={event?.data?.isHomeCourtQuestionRequired}
                            />
                        )}
                        {move.showModal && !move.showCreateForm && !move.showCreateAutomated && (
                            <Popup
                                className="popup-sm"
                                popUpClassName={popupStyles.eventDrawCreateEditPopup}
                                onCloseClick={closeModals}
                                config={{
                                    fullScreen: false,
                                    noPadding: true,
                                    scrollable: false,
                                    showCloseIcon: true,
                                    title: (move.copy || preventSelectMove ? 'Add' : 'Move') + (selectedLength ? ` ${selectedLength} player(s)` : ''),
                                    isSideBar: true,
                                }}
                            >
                                <div className={popupStyles.content}>
                                    <div className={popupStyles.section} data-testid="draw-edit-page.div-2080">
                                        <div className={`radio radio-large mb24 d-flex ${move.toDrawId === 'newDraw' ? 'selected' : ''}`} onClick={() => moveOption('newDraw')} data-testid="modal.draw-edit.move-players.new-draw-option">
                                            <div className="radio-wrapper">
                                                <div className={`radio-check`} data-testid="modal.draw-edit.move-players.new-draw-option.radio-check"><Img src="/img/icons/checkmark-icon.svg" /></div>
                                            </div>
                                            <div className="label">
                                                <div className="text text-medium text-dark" data-testid="draw-edit-page.div-2086">{move.copy || preventSelectMove ? 'Add' : 'Move'} to new draw</div>
                                            </div>
                                        </div>
                                        Creating a new draw automatically will allow you to quickly get started. Set your draw type, number of groups, and how you want players placed and we’ll generate the draw for you.
                                        <div className="div mt16 mb16" />
                                        <div className="mb24" data-testid="draw-edit-page.div-2091">{move.copy || preventSelectMove ? 'Add' : 'Move'} to existing draw</div>
                                        {getDrawsForMoving().map(drw => (
                                            <div className={`radio radio-large mb24 d-flex ${move.toDrawId === drw.id ? 'selected' : ''}`} onClick={() => moveOption(drw.id)} key={drw.id} data-testid={`modal.draw-edit.move-players.draw-option-${drw.id}`}>
                                                <div className="radio-wrapper">
                                                    <div className={`radio-check`}><Img src="/img/icons/checkmark-icon.svg" /></div>
                                                </div>
                                                <div className="label">
                                                    <div className="text text-medium text-dark">{drw.name}</div>
                                                </div>
                                            </div>
                                        ))}
                                        <div className="div mt16 mb16" />
                                        {move.toDrawId === 'newDraw' && (
                                            <div
                                                type="button"
                                                className={`btn btn-xl btn-block btn-primary text-uppercase`}
                                                onClick={() => movePlayers('manual')}
                                                data-testid="modal.draw-edit.move-players.create-manual-draw-btn"
                                            >
                                                Create new draw
                                            </div>
                                        )}
                                        <button
                                            type="button"
                                            className={`btn btn-xl btn-block btn-primary text-uppercase`}
                                            disabled={!move.toDrawId || move.isSaving}
                                            onClick={() => movePlayers('automated')}
                                            data-testid="modal.draw-edit.move-players.confirm-btn"
                                        >
                                            {move.isSaving && (<i className="fas fa-circle-notch fa-spin" />)} {move.toDrawId === 'newDraw' ? 'Create automated round robin' : moveButtonLabel}
                                        </button>
                                    </div>
                                </div>
                            </Popup>
                        )}
                        {message?.showModal && (
                            <MessagePopUp
                                onCloseClick={closeMessagePopUp}
                                title={message.title}
                                subTitle={message.subTitle}
                                placeHolder={message.placeHolder}
                                sendText={message.ctaText}
                                onSendClick={({ values }) => {
                                    dispatch(drawEditActions.sendMessageToPlayers(values.notes, message.eventId, message.drawId, values.organizerCopy));
                                    closeMessagePopUp();
                                }}
                            />
                        )}
                        {!!confirmation && (
                            <ConfirmActionPopup
                                onCloseClick={() => {
                                    setConfirmation(false);
                                }}
                                onCtaClick={handlePublishDrawsClick}
                                confirmationTitle="Confirm publishing draws?"
                                confirmationMessage=""
                            />
                        )}
                        {drawCreateWelcomeModal?.showModal && (
                            <CreateDrawsWelcomePopUp
                                onCloseClick={() => {
                                    toggleCreateDrawWelcomePopUp();
                                    toggleDrawsNav();
                                }}
                                onCtaClick={() => {
                                    toggleCreateDrawWelcomePopUp();
                                    toggleDrawsNav();
                                }}
                            />
                        )}
                        {showPostScoreDateCrossed && hasCrossedMaxPostScoreDate && (
                            <MaxPostScoreDateCrossedPopUp
                                onCloseClick={() => setShowPostScoreDateCrossed(false)}
                                onCtaClick={() => setShowPostScoreDateCrossed(false)}
                            />
                        )}
                        {unsavedModal.showModal && (
                            <Modal visible={true} onClickBackdrop={closeModals}>
                                <div className="modal-header">
                                    <div className="text-medium" data-testid="modal.draw-edit.unsaved-warning.title">Warning!</div>
                                    <div className="close-icon" onClick={closeModals} data-testid="modal.draw-edit.unsaved-warning.close-btn"><i className="utr utr-close" /></div>
                                </div>

                                <div className={`modal-body`}>
                                    <p className="mb24 text-center" data-testid="modal.draw-edit.unsaved-warning.message">{unsavedModal.text || 'Leave Draw? Your unsaved changes may be lost.'}</p>
                                    <div className="row">
                                        <div className="col-md-6">
                                            <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={closeModals} data-testid="modal.draw-edit.unsaved-warning.cancel-btn">Cancel</button>
                                        </div>
                                        <div className="col-md-6">
                                            <button type="button" className={`btn btn-xl btn-block btn-default`} onClick={() => unsavedModal.callback()} data-testid="modal.draw-edit.unsaved-warning.proceed-btn">Proceed</button>
                                        </div>
                                    </div>
                                </div>
                            </Modal>
                        )}
                        {postScore.showModal && (
                            <EventPostScorePopup
                                event={event.data}
                                drawsDict={draws.drawsDict} // kept to support old datamodel
                                draw={draw} // new datamodel
                                players={players.data}
                                playersDict={playersDict}
                                playersDictByMemberId={playersDictByMemberId}
                                teams={teams.data}
                                teamsDict={teamsDict}
                                selectedDrawId={currentDraw.data.id}
                                roundIndex={postScore.roundIndex}
                                matchIndex={postScore.matchIndex}
                                activeRound={selectedRound}
                                matches={draw.rounds[postScore.roundIndex]?.matches}
                                onCloseClick={closeModals}
                                postScoreAction={drawEditActions.postScore}
                            />
                        )}
                        {showDrawDivisionAssociationPopup && (
                            <>{drawDivisionAssociationPopup()}</>
                        )}
                        {!!failedMemberIds?.length && !move.showModal && (
                            <EventDeskFailedMembersPopup
                                failedMemberIds={failedMemberIds}
                                playersDictByMemberId={playersDictByMemberId}
                                onCloseClick={handleFailedMemberConfirm}
                            />
                        )}

                        {showConfirmDeleteDraw && (
                            <ConfirmActionPopup
                                confirmationTitle="Delete Draw?"
                                confirmationMessage="Once a draw is deleted, that action cannot be undone. If any matches in the draw have been added to a schedule, they will be removed from the schedule."
                                onCloseClick={onCloseDrawDeleteConfirmPopup}
                                onCtaClick={handleDrawDeleteConfirmation}
                                disabled={submittingDeleteDraw}
                                data-testid="modal.draw-edit.delete-draw"
                            />
                        )}

                        {showConfirmDeleteScheduledDraw && (
                            <ConfirmActionPopup
                                confirmationTitle="Cancel Scheduled Publishing"
                                confirmationMessage="Are you sure you want to cancel the selected scheduled draw(s) publishing?"
                                onCloseClick={() => setShowConfirmDeleteScheduledDraw(false)}
                                onCtaClick={() => handleRemoveScheduledConfirm()}
                            />
                        )}

                        {showConfirmSchedulePublishDraw && (
                            <ConfirmActionPopup
                                confirmationTitle="Schedule Publishing"
                                confirmationMessage="Confirm schedule publish for the selected draw(s)?"
                                onCloseClick={() => setShowConfirmSchedulePublishDraw(false)}
                                onCtaClick={() => handleSchedulePublishConfirm()}
                            />
                        )}

                        <NavigationPrompt
                            renderIfNotActive={false}
                            when={(crntLocation, nextLocation) => currentDraw.unsavedChanges && !nextLocation?.pathname.startsWith(crntLocation.pathname)}
                        >
                            {({ isActive, onCancel, onConfirm }) => {
                                if (isActive) {
                                    return (
                                        <Modal visible={true} onClickBackdrop={onCancel}>
                                            <div className="modal-header">
                                                <div className="text-medium" data-testid="modal.draw-edit.navigation-warning.title">Warning!</div>
                                                <div className="close-icon" onClick={onCancel} data-testid="modal.draw-edit.navigation-warning.close-btn"><i className="utr utr-close" /></div>
                                            </div>

                                            <div className={`modal-body`}>
                                                <p className="mb24 text-center" data-testid="modal.draw-edit.navigation-warning.message-1">You have unsaved changes. If you leave before saving, your changes will be lost.</p>
                                                <p className="mb24 text-center" data-testid="modal.draw-edit.navigation-warning.message-2">Are you sure you want to leave the page?</p>
                                                <div className="row">
                                                    <div className="col-md-6">
                                                        <button type="button" className={`btn btn-xl btn-block btn-primary`} onClick={onCancel} data-testid="modal.draw-edit.navigation-warning.no-btn">No</button>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <button type="button" className={`btn btn-xl btn-block btn-default`} onClick={onConfirm} data-testid="modal.draw-edit.navigation-warning.yes-btn">Yes</button>
                                                    </div>
                                                </div>
                                            </div>

                                        </Modal>
                                    );
                                }
                                return null;
                            }}
                        </NavigationPrompt>
                    </div>
                )}
            </div>
        );
    }

    return <Splash show />;
};

DrawEditPageV2.propTypes = {
    match: PropTypes.objectOf(any).isRequired,
    history: PropTypes.objectOf(any).isRequired,
    location: PropTypes.objectOf(any).isRequired,
};

export default withStatsigEventUpdate(DrawEditPageV2);
